import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'

export default {
  /**
  * 获取交易明细表格数据
  * @param {string} accountNo 账号
  * @param {string} currencyType 币种
  * @param {string} startDate 开始日期
  * @param {string} endDate 结束日期
  * @param {number} loanFlag 查询类型
  * @param {number} logRecordFlag 1
  * @param {number} currentBusinessCode 10100100
  */
  getTableData (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/queryAccountDetails.do`, params, {
      ...config,
      convertPageNumAndSize: true
    }, 'URLEncoded')
  },

  /**
  * 电子回单单个下载
  * @param {string} receiptNo
  * @param {string} languageType
  */
  downloadEreceipt (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/ereceipt/download`, params, {
      ...config,
      responseType: 'blob'
    }, 'URLEncoded')
  },

  /**
  * 电子回单批量下载详情
  * @param {string} accNo
  * @param {string} startTime
  * @param {string} endTime
  * @param {string} transType
  */
  preBatchDownload (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/ereceipt/preBatchDownload`, params, {
      ...config
    }, 'URLEncoded')
  },

  /**
  * 电子回单批量下载
  * @param {string} email
  * @param {string} id
  * @param {string} languageType
  */
  batchDownloadConfirm (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/ereceipt/batchDownloadConfirm`, params, {
      ...config
    }, 'URLEncoded')
  },

  /**
  * 电子回单详情
  * @param {string} receiptNo
  */
  ereceiptDetail (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/ereceipt/details`, params, {
      ...config
    }, 'URLEncoded')
  },

  /**
  * 电子回单发送邮箱
  * @param {string} email
  * @param {string} receiptId
  * @param {string} languageType
  */
  singleReceiptSend (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/api/ereceipt/singleReceiptSend`, params, {
      ...config
    }, 'URLEncoded')
  }
}
